import axios from 'axios';
import { reactLocalStorage } from 'reactjs-localstorage';
// let Baseurl = "http://192.168.32.17:3004/";
//let Baseurl = 'http://localhost:3001/';
//let Baseurl = 'http://api.inbillsolutions.com/';
let Baseurl = 'http://rtoapi.girnarcare.com/';


function loginSessionLogout(apiError) {
  //console.log('catch error on api helper',apiError.response);
  if (apiError.response.status === 403 ) {
    var url = window.location.href;
    var arr = url.split("/");
    reactLocalStorage.clear();
    url = arr[0] + "//" + arr[2] + "/admin/login";
    window.location.href = url;
  }
}

const Apihelpers = {
  getBaseUrl: function () {
    return Baseurl;
  },

  getdataresponse: function (apiname) {
    var headers = {
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Credentials': true,
      'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + reactLocalStorage.get('authToken'),
    };

    //get response using promise
    return new Promise((resolve, reject) => {
      axios
        .get(Baseurl + apiname, { headers: headers })
        .then(function (response) {
          if (response.status) {
            resolve(response);
          }
        })
        .catch(function (error) {
          loginSessionLogout(error);
          reject(error);
        });
    });
  },
  downloadFileresponse: function (apiname) {
    return new Promise((resolve, reject) => {
      axios
        .get(Baseurl + apiname, { responseType: 'blob' })
        .then(response => {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },

  postdataresponse: function (apiname, data) {
    var headers = {
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
      Authorization: 'Bearer ' + reactLocalStorage.get('authToken'),
      'Content-Type': 'application/json',
    };

    return new Promise((resolve, reject) => {
      axios
        .post(Baseurl + apiname, data, { headers: headers })
        .then(function (response) {
          if (response.status === 201) {
            resolve(response);
          }
        })
        .catch(function (error) {
          loginSessionLogout(error);
          reject(error);
        });
    });
  },
  postdataresponseInternal: function (apiname, internalToken, data) {
    var headers = {
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
      Authorization: 'Bearer ' + internalToken,
      'Content-Type': 'application/json',
    };

    return new Promise((resolve, reject) => {
      axios
        .post(Baseurl + apiname, data, { headers: headers })
        .then(function (response) {
          if (response.status === 201) {
            resolve(response);
          }
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },

  postdataresponseWOToken: function (apiname, data) {
    var headers = {
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Credentials': true,
      'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
      'Content-Type': 'application/json',
    };

    return new Promise((resolve, reject) => {
      axios
        .post(Baseurl + apiname, data, { headers: headers })
        .then(function (response) {
          if (response.status === 200) {
            resolve(response);
          }
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },
  postFormDataResponse: function (apiname, data) {
    var headers = {
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
      Authorization: 'Bearer ' + reactLocalStorage.get('authToken'),
      // 'Authorization': "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIzIiwianRpIjoiYzViY2RhMzU0M2NkZWMzZGVlOWZjMzAwYWNkNTY5NzEwMjA0ZWEyM2JhNzk5ODViNzE1ZDk0Y2UwMjA2ZGVlMTgyYzVkYzgzNzFhM2FlZWUiLCJpYXQiOjE1Nzk5NDA0MjUsIm5iZiI6MTU3OTk0MDQyNSwiZXhwIjoxNjExNTYyODI1LCJzdWIiOiIxIiwic2NvcGVzIjpbXX0.ORYO1VyOexEBgslnOEBRzv3Nd4rWSGTlbeEAZrFHjoelHhjjGEy2eRO0Xmg3zQ3eWFC2XHOjXMHXmQ1U8uOo0PGKKPxKC9cFD8RVVjmVd_CUytjrRc3nMoo8lJeo3Z8G2HUHMsM1396qe2qM-GyUlRWSEX6KtynwQqC1FiLO4SjAx_5mZizjbGFWGm5GyHG6wOCskwpkG17HriT3aPW8XuEwcJbyq8rPTW1JQZ0BfS6AgE98KYiKN3NsEijIR_SEoO6_3ly9ri83lWcFO1cf1NVGuInRzEgxmW0qt2MwbZFiqiW7MkKO54cbSbMTWwcuL0ur8cSQ4twfgET9cP_zDIe7gox4eioXZCUwoH17ZO0uoQaVbl8XQE8l_jMKshaEiu9T0QLMwilTNPtH6OnzMqwL64tp9M6re79bxcLyuwNipzfTT7y12I_0iqxGPE29J2wSnaUcQaFYP54tjtdEZeHAmR9CugtTUSHe6f3IZ2UXaPg0MJL1bzLhte4lS4HbR0mG2E2qecnA8WZR1pROBcaW1I31DctPH8GDPH2VNmcJ2WO9Z0ZOPnX7FUTwrqaCAdJHrV5lXswI_3uX6XnTcauhosrmQuKE0zR-5kuMcX4wGKdty7tC3KABM8bUThBJAATGlc7F-NoeATPb6EZW9sMuFb_5eRhZs6Akc8iNNDY",
      Accept: 'application/json',
      'Content-Type': 'multipart/form-data',
    };

    return new Promise((resolve, reject) => {
      axios
        .post(Baseurl + apiname, data, { headers: headers })
        .then(function (response) {
          if (response.status === 200) {
            resolve(response);
          }
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },
  postdataresponseMultipart: function (apiname, data) {
    var headers = {
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
      Authorization: 'Bearer ' + reactLocalStorage.get('authToken'),
      Accept: 'application/json',
      'content-type': 'multipart/form-data',
    };

    return new Promise((resolve, reject) => {
      axios
        .post(Baseurl + apiname, data, { headers: headers })
        .then(function (response) {
          if (response.status === 201) {
            resolve(response);
          }
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },

  postdatarctransfer: function (apiname, data) {
    var headers = {
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Credentials': true,
      'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
      'Content-Type': 'application/json',
    };
    //console.log('data in Helper', Object.fromEntries(data));
    return new Promise((resolve, reject) => {
      axios
        .post(Baseurl + apiname, data, { headers: headers })
        .then(function (response) {
          if (response.status === 201) {
            resolve(response);
          }
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },

  //get city list
  getCityListRes: function (apiname) {
    var headers = {
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Credentials': true,
      'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyZW1haWwiOiJzYWNoaW4uZ3VwdGFAZ2lybmFyc29mdC5jby5pbiIsImlhdCI6MTYwNzY2MzQwNSwiZXhwIjoxNjM5MTk5NDA1fQ.absXkW4ZV99Hklwvs7wv2arUFjLVdtLnEOmmvp9xsoo',
    };

    //get response using promise
    return new Promise((resolve, reject) => {
      axios
        .get(Baseurl + apiname, { headers: headers })
        .then(function (response) {
          if (response.status) {
            resolve(response);
          }
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },
  get_rcprime_details_apihelper: function (apiname, data) {
    var headers = {
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'POST',
      Authorization: data.authorization_Token,
      'Content-Type': 'application/json',
    };
    //Authorization: 'Bearer ' + reactLocalStorage.get('authToken')
    return new Promise((resolve, reject) => {
      axios
        .post(apiname, data, { headers: headers })
        .then(function (result) {
          console.log(result);
          if (result.status == 201) {
            resolve(result);
          }
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },
  get_adhaarExtaction_details_apihelper: function (apiname, data, headerData) {
    var headers = {
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'POST',
      Authorization: headerData.authorization_Token,
      'Content-Type': 'application/json',
    };
    //Authorization: 'Bearer ' + reactLocalStorage.get('authToken')
    return new Promise((resolve, reject) => {
      axios
        .post(apiname, data, { headers: headers })
        .then(function (result) {
          console.log(result);
          if (result.status) {
            resolve(result);
          }
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },
  createAndDownloadPdf: function (apiname, data) {
    var headers = {
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'POST',
      Authorization: 'Bearer ' + reactLocalStorage.get('authToken'),
      'Content-Type': 'application/json',
    };
    console.log(reactLocalStorage);
    return new Promise((resolve, reject) => {
      axios
        .post(Baseurl + apiname, data, { headers: headers })
        .then(function (response) {
          if (response.status === 201) {
            resolve(response);
          }
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },
  getBrandList: function (apiname, data) {// added by shreeprana
    var headers = {
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
      Authorization: 'Bearer ' + reactLocalStorage.get('authToken'),
      'Content-Type': 'application/json',
    };

    return new Promise((resolve, reject) => {
      axios
        .post(Baseurl + apiname, data, { headers: headers })
        .then(function (response) {
          if (response.status === 201) {
            resolve(response);
          }
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },
  getBrandModelsList: function (apiname, data) {
    var headers = {
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
      Authorization: 'Bearer ' + reactLocalStorage.get('authToken'),
      'Content-Type': 'application/json',
    };

    return new Promise((resolve, reject) => {
      axios
        .post(Baseurl + apiname, data, { headers: headers })
        .then(function (response) {
          if (response.status === 201) {
            resolve(response);
          }
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },
  getVariantList: function (apiname, data) {
    var headers = {
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
      Authorization: 'Bearer ' + reactLocalStorage.get('authToken'),
      'Content-Type': 'application/json',
    };
    return new Promise((resolve, reject) => {
      axios
        .post(Baseurl + apiname, data, { headers: headers })
        .then(function (response) {
          if (response.status === 201) {
            resolve(response);
          }
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },
  UniqueData: function (apiname) {
    var headers = {
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
      Authorization: 'Bearer ' + reactLocalStorage.get('authToken'),
      'Content-Type': 'application/json',
    };
    return new Promise((resolve, reject) => {
      axios
        .post(Baseurl + apiname, { headers: headers })
        .then(function (response) {
          if (response.status === 201) {
            resolve(response);
          }
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },
  get_Filter_data_on_date_based: function (apiname, data) {
    var headers = {
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'POST',
      Authorization: 'Bearer ' + reactLocalStorage.get('authToken'),
      'Content-Type': 'application/json',
    };
    return new Promise((resolve, reject) => {
      axios
        .post(Baseurl + apiname, data, { headers: headers })
        .then(function (response) {
          if (response.status === 201) {
            resolve(response);
          }
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },

  getdataresponse_variant_mapping: function (apiname, data) {
    var headers = {
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Credentials': true,
      'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + reactLocalStorage.get('authToken'),
    };

    //get response using promise
    return new Promise((resolve, reject) => {
      axios
        .post(Baseurl + apiname, data, { headers: headers })
        .then(function (response) {
          if (response.status) {
            resolve(response);
          }
        })
        .catch(function (error) {
          reject(error);
        });
    });
  },
};
export default Apihelpers;
